import { useEffect } from "react"
import { motion, useAnimation } from "framer-motion"
import clsx from "clsx"

import animate from "./animate"
import styles from "./loading.module.scss"
import i18n from "../../i18n"

interface Props {
  className?: string
  message?: string
  size: "small" | "medium" | "large" | "custom"
}

const Loading: React.FC<Partial<Props>> = (props) => {
  const headAnimation = useAnimation()
  const earAnimation = useAnimation()
  const helmetAnimation = useAnimation()
  const faceAnimation = useAnimation()
  const rightEyeAnimation = useAnimation()
  const leftEyeAnimation = useAnimation()

  useEffect(() => {
    animate({
      head: headAnimation,
      ear: earAnimation,
      helmet: helmetAnimation,
      face: faceAnimation,
      rightEye: rightEyeAnimation,
      leftEye: leftEyeAnimation
    })
  }, [])

  const SVG = () => (
    <svg version="1.1" viewBox="0 0 300 173" xmlns="http://www.w3.org/2000/svg">
      <motion.path
        d="m38.868 24.125 19.558 0.28096c0.01648 0.09614-0.36489 0.42094-0.10932 0.45429 50.54-1.0163 50.56-1.1895 200.79 4.6273 0 0 29.307 2.6189 38.66 39.658 9.3532 37.039-17.21 59.611-17.21 59.611s-7.4202 6.4849-23.009 9.1038c-15.589 2.6189-204.52 34.919-204.52 34.919s-8.8586 1.3512-19.094-4.1434c-7.5779-4.0679-15.442-12.57-22.683-24.852-14.217-32.362-10.912-60.422-10.912-60.422s3.2424-40.156 24.817-53.376c5.8257-4.2338 13.718-5.8613 13.718-5.8613z"
        fillOpacity="0"
        fill="#cfd8dc"
        animate={headAnimation}
      />
      <motion.ellipse
        transform="matrix(.97854 -.20607 .12656 .99196 0 0)"
        cx="25.499"
        cy="105.2"
        rx="37.09"
        ry="60.257"
        fillOpacity="0"
        fill="#eceff1"
        animate={earAnimation}
      />
      <motion.path
        d="m58.215 24.85s15.785-28.219 48.942-24.515c34.568 1.7637 116.67 6.9224 116.67 6.9224 11.279 1.4011 15.044 1.6198 26.428 8.2221 4.9529 2.8435 8.9 6.3106 10.735 8.3895 1.2004 1.3602-0.68673 4.0202-0.68673 4.0202s-5.4759 8.6981-8.1255 12.745l-131.35-0.26455s-6.8367-9.4458-17.955-13.153c-9.6396-3.2141-24.113-1.3795-44.654-2.367z"
        fillOpacity="0"
        fill="#eceff1"
        animate={helmetAnimation}
      />
      <motion.path
        d="m102.1 48.443 168.48-1.3718s20.452 0.62355 23.695 35.293c-0.12471 34.545-21.076 37.912-21.076 37.912l-159.13 22.947s-11.711 2.9719-14.548-6.7006c-0.28956-4.0879-0.56827-9.2296-0.66684-17.493-1.1224-33.422-3.2424-61.108-3.2424-61.108s-0.37413-7.3579 6.4849-9.4779z"
        fill="#0C4FFF"
        fillOpacity="0"
        animate={faceAnimation}
      />
      <motion.rect
        transform="matrix(.9981 -.061688 .049035 .9988 0 0)"
        x="153.69"
        y="70.009"
        width="15.598"
        height="64.584"
        ry="7.7991"
        fill="#03ffff"
        fillOpacity="0"
        animate={rightEyeAnimation}
      />
      <motion.rect
        transform="matrix(.99807 -.062086 .04872 .99881 0 0)"
        x="241.34"
        y="72.94"
        width="13.436"
        height="55.989"
        ry="6.7612"
        fill="#03ffff"
        fillOpacity="0"
        animate={leftEyeAnimation}
      />
    </svg>
  )

  return (
    <div
      className={clsx([styles.loading, props.className])}
      data-size={props.size}
      {...props}
    >
      <SVG />
      {props.message && (
        <span>{props.message}</span>
      )}
    </div>
  )
}

Loading.defaultProps = {
  message: i18n["common.loading"],
  size: "medium"
}

export default Loading